/**
 * HilerIQ is a first-party Hiler Mortgage platform shared by borrowers and
 * real estate agents. It is intentionally exempt from the general
 * external-link interstitial (see ExternalLinkWarning).
 */
export const HILERIQ_URL = "https://hileriq.com";
export const HILERIQ_LABEL = "Access HilerIQ";

/** True for hileriq.com and its subdomains. */
export const isHilerIQUrl = (url: string): boolean => {
  try {
    const host = new URL(url).hostname.toLowerCase().replace(/^www\./, "");
    return host === "hileriq.com" || host.endsWith(".hileriq.com");
  } catch {
    return false;
  }
};